import styled from "styled-components";
import ContentLayout from "components/layout/ContentLayout";

export const Wrapper = styled(ContentLayout)`
  display: grid;
  gap: 12px;
`;
